/* parser generated by jison 0.4.18 */
/*
  Returns a Parser object of the following structure:

  Parser: {
    yy: {}
  }

  Parser.prototype: {
    yy: {},
    trace: function(),
    symbols_: {associative list: name ==> number},
    terminals_: {associative list: number ==> name},
    productions_: [...],
    performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate, $$, _$),
    table: [...],
    defaultActions: {...},
    parseError: function(str, hash),
    parse: function(input),

    lexer: {
        EOF: 1,
        parseError: function(str, hash),
        setInput: function(input),
        input: function(),
        unput: function(str),
        more: function(),
        less: function(n),
        pastInput: function(),
        upcomingInput: function(),
        showPosition: function(),
        test_match: function(regex_match_array, rule_index),
        next: function(),
        lex: function(),
        begin: function(condition),
        popState: function(),
        _currentRules: function(),
        topState: function(),
        pushState: function(condition),

        options: {
            ranges: boolean           (optional: true ==> token location info will include a .range[] member)
            flex: boolean             (optional: true ==> flex-like lexing behaviour where the rules are tested exhaustively to find the longest match)
            backtrack_lexer: boolean  (optional: true ==> lexer regexes are tested in order and for each matching regex the action code is invoked; the lexer terminates the scan when a token is returned by the action code)
        },

        performAction: function(yy, yy_, $avoiding_name_collisions, YY_START),
        rules: [...],
        conditions: {associative list: name ==> set},
    }
  }


  token location info (@$, _$, etc.): {
    first_line: n,
    last_line: n,
    first_column: n,
    last_column: n,
    range: [start_number, end_number]       (where the numbers are indexes into the input string, regular zero-based)
  }


  the parseError function receives a 'hash' object with these members for lexer and parser errors: {
    text:        (matched text)
    token:       (the produced terminal token, if any)
    line:        (yylineno)
  }
  while parser (grammar) errors will also provide these members, i.e. parser errors deliver a superset of attributes: {
    loc:         (yylloc)
    expected:    (string describing the set of expected tokens)
    recoverable: (boolean: TRUE when the parser has a error recovery rule available for this particular error)
  }
*/
var parser = (function(){
var o=function(k,v,o,l){for(o=o||{},l=k.length;l--;o[k[l]]=v);return o},$V0=[1,3],$V1=[1,6],$V2=[1,4],$V3=[1,5],$V4=[2,5],$V5=[1,12],$V6=[5,7,13,19,21,23,24,26,28,31,36,39,48],$V7=[7,13,19,21,23,24,26,28,31,36,39],$V8=[7,12,13,19,21,23,24,26,28,31,36,39],$V9=[7,13,48],$Va=[1,42],$Vb=[1,41],$Vc=[1,49],$Vd=[7,13,29,32,37,45,48],$Ve=[1,57],$Vf=[1,59],$Vg=[1,60],$Vh=[1,61],$Vi=[7,13,32,41,45,48],$Vj=[7,13,32,34,37,41,45,48];
var parser = {trace: function trace () { },
yy: {},
symbols_: {"error":2,"start":3,"eol":4,"GG":5,"document":6,"EOF":7,":":8,"DIR":9,"options":10,"body":11,"OPT":12,"NL":13,"line":14,"statement":15,"commitStatement":16,"mergeStatement":17,"cherryPickStatement":18,"acc_title":19,"acc_title_value":20,"acc_descr":21,"acc_descr_value":22,"acc_descr_multiline_value":23,"section":24,"branchStatement":25,"CHECKOUT":26,"ref":27,"BRANCH":28,"ORDER":29,"NUM":30,"CHERRY_PICK":31,"COMMIT_ID":32,"STR":33,"PARENT_COMMIT":34,"commitTags":35,"MERGE":36,"COMMIT_TYPE":37,"commitType":38,"COMMIT":39,"commit_arg":40,"COMMIT_MSG":41,"NORMAL":42,"REVERSE":43,"HIGHLIGHT":44,"COMMIT_TAG":45,"EMPTYSTR":46,"ID":47,";":48,"$accept":0,"$end":1},
terminals_: {2:"error",5:"GG",7:"EOF",8:":",9:"DIR",12:"OPT",13:"NL",19:"acc_title",20:"acc_title_value",21:"acc_descr",22:"acc_descr_value",23:"acc_descr_multiline_value",24:"section",26:"CHECKOUT",28:"BRANCH",29:"ORDER",30:"NUM",31:"CHERRY_PICK",32:"COMMIT_ID",33:"STR",34:"PARENT_COMMIT",36:"MERGE",37:"COMMIT_TYPE",39:"COMMIT",41:"COMMIT_MSG",42:"NORMAL",43:"REVERSE",44:"HIGHLIGHT",45:"COMMIT_TAG",46:"EMPTYSTR",47:"ID",48:";"},
productions_: [0,[3,2],[3,3],[3,4],[3,5],[6,0],[6,2],[10,2],[10,1],[11,0],[11,2],[14,2],[14,1],[15,1],[15,1],[15,1],[15,2],[15,2],[15,1],[15,1],[15,1],[15,2],[25,2],[25,4],[18,3],[18,5],[18,4],[18,6],[18,6],[18,4],[18,6],[17,2],[17,4],[17,4],[17,3],[17,5],[17,5],[17,5],[17,6],[17,5],[17,6],[17,7],[17,7],[17,7],[17,7],[17,7],[17,7],[16,2],[16,2],[16,3],[16,4],[16,4],[16,3],[16,4],[16,4],[16,5],[16,5],[16,6],[16,6],[16,6],[16,6],[16,6],[16,6],[16,3],[16,4],[16,4],[16,5],[16,5],[16,5],[16,5],[16,6],[16,6],[16,6],[16,6],[16,6],[16,6],[16,7],[16,7],[16,7],[16,7],[16,7],[16,7],[16,6],[16,6],[16,6],[16,6],[16,6],[16,6],[16,8],[16,8],[16,8],[16,8],[16,8],[16,8],[16,8],[16,8],[16,8],[16,8],[16,8],[16,8],[16,8],[16,8],[16,8],[16,8],[16,8],[16,8],[16,8],[16,8],[16,8],[16,8],[16,8],[16,8],[40,0],[40,1],[38,1],[38,1],[38,1],[35,2],[35,2],[35,3],[35,3],[27,1],[27,1],[4,1],[4,1],[4,1]],
performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate /* action[1] */, $$ /* vstack */, _$ /* lstack */) {
/* this == yyval */

var $0 = $$.length - 1;
switch (yystate) {
case 2:
 return $$[$0]; 
break;
case 3:
 return $$[$0-1]; 
break;
case 4:
yy.setDirection($$[$0-3]); return $$[$0-1];
break;
case 6:
 yy.setOptions($$[$0-1]); this.$ = $$[$0]
break;
case 7:
$$[$0-1] +=$$[$0]; this.$=$$[$0-1]
break;
case 9:
this.$ = []
break;
case 10:
$$[$0-1].push($$[$0]); this.$=$$[$0-1];
break;
case 11:
this.$ =$$[$0-1]
break;
case 16:
 this.$=$$[$0].trim();yy.setAccTitle(this.$); 
break;
case 17: case 18:
 this.$=$$[$0].trim();yy.setAccDescription(this.$); 
break;
case 19:
yy.addSection($$[$0].substr(8));this.$=$$[$0].substr(8);
break;
case 21:
yy.checkout($$[$0])
break;
case 22:
yy.branch($$[$0])
break;
case 23:
yy.branch($$[$0-2], $$[$0])
break;
case 24:
yy.cherryPick($$[$0], '', undefined)
break;
case 25:
yy.cherryPick($$[$0-2], '', undefined,$$[$0])
break;
case 26:
yy.cherryPick($$[$0-1], '', $$[$0])
break;
case 27:
yy.cherryPick($$[$0-3], '', $$[$0],$$[$0-1])
break;
case 28:
yy.cherryPick($$[$0-3], '', $$[$0-2],$$[$0])
break;
case 29:
yy.cherryPick($$[$0], '', $$[$0-2])
break;
case 30:
yy.cherryPick($$[$0-2], '', $$[$0-4],$$[$0])
break;
case 31:
yy.merge($$[$0],'','', undefined)
break;
case 32:
yy.merge($$[$0-2], $$[$0],'', undefined)
break;
case 33:
yy.merge($$[$0-2],'', $$[$0], undefined)
break;
case 34:
yy.merge($$[$0-1], '','',$$[$0])
break;
case 35:
yy.merge($$[$0-3], $$[$0],'', $$[$0-2])
break;
case 36:
yy.merge($$[$0-3], '',$$[$0], $$[$0-2])
break;
case 37:
yy.merge($$[$0-3], '',$$[$0-1], $$[$0])
break;
case 38:
yy.merge($$[$0-4], $$[$0-2], $$[$0], undefined)
break;
case 39:
yy.merge($$[$0-3], $$[$0-1], '', $$[$0])
break;
case 40:
yy.merge($$[$0-4], $$[$0],$$[$0-2], undefined)
break;
case 41:
yy.merge($$[$0-5], $$[$0-3], $$[$0-1], $$[$0])
break;
case 42:
yy.merge($$[$0-5], $$[$0], $$[$0-3], $$[$0-2])
break;
case 43:
yy.merge($$[$0-5], $$[$0-3], $$[$0], $$[$0-2])
break;
case 44:
yy.merge($$[$0-5], $$[$0-1], $$[$0-3], $$[$0])
break;
case 45:
yy.merge($$[$0-5], $$[$0], $$[$0-2], $$[$0-4])
break;
case 46:
yy.merge($$[$0-5], $$[$0-2], $$[$0], $$[$0-4])
break;
case 47:
yy.commit($$[$0])
break;
case 48:
yy.commit('','',yy.commitType.NORMAL,$$[$0])
break;
case 49:
yy.commit('','',$$[$0], undefined)
break;
case 50:
yy.commit('','',$$[$0],$$[$0-2])
break;
case 51:
yy.commit('','',$$[$0-1],$$[$0])
break;
case 52:
yy.commit('',$$[$0],yy.commitType.NORMAL, undefined)
break;
case 53:
yy.commit('',$$[$0-1],yy.commitType.NORMAL,$$[$0])
break;
case 54:
yy.commit('',$$[$0],yy.commitType.NORMAL,$$[$0-2])
break;
case 55:
yy.commit('',$$[$0-2],$$[$0], undefined)
break;
case 56:
yy.commit('',$$[$0],$$[$0-2], undefined)
break;
case 57:
yy.commit('',$$[$0-3],$$[$0-1],$$[$0])
break;
case 58:
yy.commit('',$$[$0-3],$$[$0],$$[$0-2])
break;
case 59:
yy.commit('',$$[$0-1],$$[$0-3],$$[$0])
break;
case 60:
yy.commit('',$$[$0],$$[$0-3],$$[$0-2])
break;
case 61:
yy.commit('',$$[$0],$$[$0-2],$$[$0-4])
break;
case 62:
yy.commit('',$$[$0-2],$$[$0],$$[$0-4])
break;
case 63:
yy.commit($$[$0],'',yy.commitType.NORMAL, undefined)
break;
case 64:
yy.commit($$[$0],'',yy.commitType.NORMAL,$$[$0-2])
break;
case 65:
yy.commit($$[$0-1],'',yy.commitType.NORMAL,$$[$0])
break;
case 66:
yy.commit($$[$0-2],'',$$[$0], undefined)
break;
case 67:
yy.commit($$[$0],'',$$[$0-2], undefined)
break;
case 68:
yy.commit($$[$0],$$[$0-2],yy.commitType.NORMAL, undefined)
break;
case 69:
yy.commit($$[$0-2],$$[$0],yy.commitType.NORMAL, undefined)
break;
case 70:
yy.commit($$[$0-3],'',$$[$0-1],$$[$0])
break;
case 71:
yy.commit($$[$0-3],'',$$[$0],$$[$0-2])
break;
case 72:
yy.commit($$[$0-1],'',$$[$0-3],$$[$0])
break;
case 73:
yy.commit($$[$0],'',$$[$0-3],$$[$0-2])
break;
case 74:
yy.commit($$[$0],'',$$[$0-2],$$[$0-4])
break;
case 75:
yy.commit($$[$0-2],'',$$[$0],$$[$0-4])
break;
case 76:
yy.commit($$[$0-4],$$[$0],$$[$0-2], undefined)
break;
case 77:
yy.commit($$[$0-4],$$[$0-2],$$[$0], undefined)
break;
case 78:
yy.commit($$[$0-2],$$[$0],$$[$0-4], undefined)
break;
case 79:
yy.commit($$[$0],$$[$0-2],$$[$0-4], undefined)
break;
case 80:
yy.commit($$[$0],$$[$0-4],$$[$0-2], undefined)
break;
case 81:
yy.commit($$[$0-2],$$[$0-4],$$[$0], undefined)
break;
case 82:
yy.commit($$[$0-3],$$[$0],yy.commitType.NORMAL,$$[$0-2])
break;
case 83:
yy.commit($$[$0-3],$$[$0-1],yy.commitType.NORMAL,$$[$0])
break;
case 84:
yy.commit($$[$0-2],$$[$0],yy.commitType.NORMAL,$$[$0-4])
break;
case 85:
yy.commit($$[$0],$$[$0-2],yy.commitType.NORMAL,$$[$0-4])
break;
case 86:
yy.commit($$[$0],$$[$0-3],yy.commitType.NORMAL,$$[$0-2])
break;
case 87:
yy.commit($$[$0-1],$$[$0-3],yy.commitType.NORMAL,$$[$0])
break;
case 88:
yy.commit($$[$0-5],$$[$0-3],$$[$0-1],$$[$0])
break;
case 89:
yy.commit($$[$0-5],$$[$0-3],$$[$0],$$[$0-2])
break;
case 90:
yy.commit($$[$0-5],$$[$0-1],$$[$0-3],$$[$0])
break;
case 91:
yy.commit($$[$0-5],$$[$0],$$[$0-3],$$[$0-2])
break;
case 92:
yy.commit($$[$0-5],$$[$0-2],$$[$0],$$[$0-4])
break;
case 93:
yy.commit($$[$0-5],$$[$0],$$[$0-2],$$[$0-4])
break;
case 94:
yy.commit($$[$0-3],$$[$0-5],$$[$0-1],$$[$0])
break;
case 95:
yy.commit($$[$0-3],$$[$0-5],$$[$0],$$[$0-2])
break;
case 96:
yy.commit($$[$0-1],$$[$0-5],$$[$0-3],$$[$0])
break;
case 97:
yy.commit($$[$0],$$[$0-5],$$[$0-3],$$[$0-2])
break;
case 98:
yy.commit($$[$0-2],$$[$0-5],$$[$0],$$[$0-4])
break;
case 99:
yy.commit($$[$0],$$[$0-5],$$[$0-2],$$[$0-4])
break;
case 100:
yy.commit($$[$0],$$[$0-4],$$[$0-2],$$[$0-6])
break;
case 101:
yy.commit($$[$0-2],$$[$0-4],$$[$0],$$[$0-6])
break;
case 102:
yy.commit($$[$0],$$[$0-2],$$[$0-4],$$[$0-6])
break;
case 103:
yy.commit($$[$0-2],$$[$0],$$[$0-4],$$[$0-6])
break;
case 104:
yy.commit($$[$0-4],$$[$0-2],$$[$0],$$[$0-6])
break;
case 105:
yy.commit($$[$0-4],$$[$0],$$[$0-2],$$[$0-6])
break;
case 106:
yy.commit($$[$0-1],$$[$0-3],$$[$0-5],$$[$0])
break;
case 107:
yy.commit($$[$0],$$[$0-3],$$[$0-5],$$[$0-2])
break;
case 108:
yy.commit($$[$0-2],$$[$0],$$[$0-5],$$[$0-4])
break;
case 109:
yy.commit($$[$0],$$[$0-2],$$[$0-5],$$[$0-4])
break;
case 110:
yy.commit($$[$0-3],$$[$0-1],$$[$0-5],$$[$0])
break;
case 111:
yy.commit($$[$0-3],$$[$0],$$[$0-5],$$[$0-2])
break;
case 112:
this.$ = ""
break;
case 113:
this.$=$$[$0]
break;
case 114:
 this.$=yy.commitType.NORMAL;
break;
case 115:
 this.$=yy.commitType.REVERSE;
break;
case 116:
 this.$=yy.commitType.HIGHLIGHT;
break;
case 117:
this.$=[$$[$0]]
break;
case 118:
this.$=['']
break;
case 119:
$$[$0-2].push($$[$0]); this.$=$$[$0-2];
break;
case 120:
$$[$0-2].push(''); this.$=$$[$0-2];
break;
}
},
table: [{3:1,4:2,5:$V0,7:$V1,13:$V2,48:$V3},{1:[3]},{3:7,4:2,5:$V0,7:$V1,13:$V2,48:$V3},{6:8,7:$V4,8:[1,9],9:[1,10],10:11,13:$V5},o($V6,[2,123]),o($V6,[2,124]),o($V6,[2,125]),{1:[2,1]},{7:[1,13]},{6:14,7:$V4,10:11,13:$V5},{8:[1,15]},o($V7,[2,9],{11:16,12:[1,17]}),o($V8,[2,8]),{1:[2,2]},{7:[1,18]},{6:19,7:$V4,10:11,13:$V5},{7:[2,6],13:[1,22],14:20,15:21,16:23,17:24,18:25,19:[1,26],21:[1,27],23:[1,28],24:[1,29],25:30,26:[1,31],28:[1,35],31:[1,34],36:[1,33],39:[1,32]},o($V8,[2,7]),{1:[2,3]},{7:[1,36]},o($V7,[2,10]),{4:37,7:$V1,13:$V2,48:$V3},o($V7,[2,12]),o($V9,[2,13]),o($V9,[2,14]),o($V9,[2,15]),{20:[1,38]},{22:[1,39]},o($V9,[2,18]),o($V9,[2,19]),o($V9,[2,20]),{27:40,33:$Va,47:$Vb},o($V9,[2,112],{40:43,35:44,32:[1,46],33:[1,48],37:[1,45],41:[1,47],45:$Vc}),{27:50,33:$Va,47:$Vb},{32:[1,51],35:52,45:$Vc},{27:53,33:$Va,47:$Vb},{1:[2,4]},o($V7,[2,11]),o($V9,[2,16]),o($V9,[2,17]),o($V9,[2,21]),o($Vd,[2,121]),o($Vd,[2,122]),o($V9,[2,47]),o($V9,[2,48],{32:[1,55],37:[1,54],41:[1,56],45:$Ve}),{38:58,42:$Vf,43:$Vg,44:$Vh},{33:[1,62]},{33:[1,63]},o($V9,[2,113]),{33:[1,64],46:[1,65]},o($V9,[2,31],{35:68,32:[1,66],37:[1,67],45:$Vc}),{33:[1,69]},{32:[1,70],45:$Ve},o($V9,[2,22],{29:[1,71]}),{38:72,42:$Vf,43:$Vg,44:$Vh},{33:[1,73]},{33:[1,74]},{33:[1,75],46:[1,76]},o($V9,[2,49],{35:77,32:[1,78],41:[1,79],45:$Vc}),o($Vi,[2,114]),o($Vi,[2,115]),o($Vi,[2,116]),o($V9,[2,52],{35:80,37:[1,81],41:[1,82],45:$Vc}),o($V9,[2,63],{35:83,32:[1,85],37:[1,84],45:$Vc}),o($Vj,[2,117]),o($Vj,[2,118]),{33:[1,86]},{38:87,42:$Vf,43:$Vg,44:$Vh},o($V9,[2,34],{32:[1,88],37:[1,89],45:$Ve}),o($V9,[2,24],{35:91,34:[1,90],45:$Vc}),{33:[1,92]},{30:[1,93]},o($V9,[2,50],{32:[1,94],41:[1,95]}),o($V9,[2,54],{37:[1,96],41:[1,97]}),o($V9,[2,64],{32:[1,99],37:[1,98]}),o($Vj,[2,119]),o($Vj,[2,120]),o($V9,[2,51],{32:[1,100],41:[1,101],45:$Ve}),{33:[1,102]},{33:[1,103]},o($V9,[2,53],{37:[1,104],41:[1,105],45:$Ve}),{38:106,42:$Vf,43:$Vg,44:$Vh},{33:[1,107]},o($V9,[2,65],{32:[1,109],37:[1,108],45:$Ve}),{38:110,42:$Vf,43:$Vg,44:$Vh},{33:[1,111]},o($V9,[2,32],{35:113,37:[1,112],45:$Vc}),o($V9,[2,33],{35:114,32:[1,115],45:$Vc}),{33:[1,116]},{38:117,42:$Vf,43:$Vg,44:$Vh},{33:[1,118]},o($V9,[2,26],{34:[1,119],45:$Ve}),o($V9,[2,29],{34:[1,120]}),o($V9,[2,23]),{33:[1,121]},{33:[1,122]},{38:123,42:$Vf,43:$Vg,44:$Vh},{33:[1,124]},{38:125,42:$Vf,43:$Vg,44:$Vh},{33:[1,126]},{33:[1,127]},{33:[1,128]},o($V9,[2,56],{35:129,41:[1,130],45:$Vc}),o($V9,[2,67],{35:131,32:[1,132],45:$Vc}),{38:133,42:$Vf,43:$Vg,44:$Vh},{33:[1,134]},o($V9,[2,55],{35:135,41:[1,136],45:$Vc}),o($V9,[2,68],{35:138,37:[1,137],45:$Vc}),{38:139,42:$Vf,43:$Vg,44:$Vh},{33:[1,140]},o($V9,[2,66],{35:141,32:[1,142],45:$Vc}),o($V9,[2,69],{35:144,37:[1,143],45:$Vc}),{38:145,42:$Vf,43:$Vg,44:$Vh},o($V9,[2,39],{37:[1,146],45:$Ve}),o($V9,[2,37],{32:[1,147],45:$Ve}),{33:[1,148]},o($V9,[2,35],{37:[1,149]}),o($V9,[2,36],{32:[1,150]}),o($V9,[2,25],{35:151,45:$Vc}),{33:[1,152]},{33:[1,153]},o($V9,[2,61],{41:[1,154]}),o($V9,[2,74],{32:[1,155]}),o($V9,[2,62],{41:[1,156]}),o($V9,[2,85],{37:[1,157]}),o($V9,[2,75],{32:[1,158]}),o($V9,[2,84],{37:[1,159]}),o($V9,[2,60],{41:[1,160]}),o($V9,[2,73],{32:[1,161]}),o($V9,[2,59],{41:[1,162],45:$Ve}),{33:[1,163]},o($V9,[2,72],{32:[1,164],45:$Ve}),{33:[1,165]},o($V9,[2,58],{41:[1,166]}),o($V9,[2,86],{37:[1,167]}),o($V9,[2,57],{41:[1,168],45:$Ve}),{33:[1,169]},{38:170,42:$Vf,43:$Vg,44:$Vh},o($V9,[2,87],{37:[1,171],45:$Ve}),o($V9,[2,71],{32:[1,172]}),o($V9,[2,82],{37:[1,173]}),o($V9,[2,70],{32:[1,174],45:$Ve}),{33:[1,175]},{38:176,42:$Vf,43:$Vg,44:$Vh},o($V9,[2,83],{37:[1,177],45:$Ve}),o($V9,[2,38],{35:178,45:$Vc}),{38:179,42:$Vf,43:$Vg,44:$Vh},{33:[1,180]},o($V9,[2,40],{35:181,45:$Vc}),{38:182,42:$Vf,43:$Vg,44:$Vh},{33:[1,183]},o($V9,[2,27],{45:$Ve}),o($V9,[2,28]),o($V9,[2,30]),{33:[1,184]},{33:[1,185]},{33:[1,186]},{38:187,42:$Vf,43:$Vg,44:$Vh},{33:[1,188]},{38:189,42:$Vf,43:$Vg,44:$Vh},{33:[1,190]},{33:[1,191]},{33:[1,192]},o($V9,[2,79],{35:193,45:$Vc}),{33:[1,194]},o($V9,[2,78],{35:195,45:$Vc}),{33:[1,196]},{38:197,42:$Vf,43:$Vg,44:$Vh},{33:[1,198]},o($V9,[2,80],{35:199,45:$Vc}),o($V9,[2,81],{35:200,45:$Vc}),{38:201,42:$Vf,43:$Vg,44:$Vh},{33:[1,202]},{38:203,42:$Vf,43:$Vg,44:$Vh},{33:[1,204]},o($V9,[2,76],{35:205,45:$Vc}),o($V9,[2,77],{35:206,45:$Vc}),{38:207,42:$Vf,43:$Vg,44:$Vh},o($V9,[2,41],{45:$Ve}),o($V9,[2,43]),o($V9,[2,42]),o($V9,[2,44],{45:$Ve}),o($V9,[2,46]),o($V9,[2,45]),o($V9,[2,102]),o($V9,[2,103]),o($V9,[2,100]),o($V9,[2,101]),o($V9,[2,105]),o($V9,[2,104]),o($V9,[2,109]),o($V9,[2,108]),o($V9,[2,107]),o($V9,[2,106],{45:$Ve}),o($V9,[2,111]),o($V9,[2,110],{45:$Ve}),o($V9,[2,99]),o($V9,[2,98]),o($V9,[2,97]),o($V9,[2,96],{45:$Ve}),o($V9,[2,94],{45:$Ve}),o($V9,[2,95]),o($V9,[2,93]),o($V9,[2,92]),o($V9,[2,91]),o($V9,[2,90],{45:$Ve}),o($V9,[2,88],{45:$Ve}),o($V9,[2,89])],
defaultActions: {7:[2,1],13:[2,2],18:[2,3],36:[2,4]},
parseError: function parseError (str, hash) {
    if (hash.recoverable) {
        this.trace(str);
    } else {
        var error = new Error(str);
        error.hash = hash;
        throw error;
    }
},
parse: function parse(input) {
    var self = this, stack = [0], tstack = [], vstack = [null], lstack = [], table = this.table, yytext = '', yylineno = 0, yyleng = 0, recovering = 0, TERROR = 2, EOF = 1;
    var args = lstack.slice.call(arguments, 1);
    var lexer = Object.create(this.lexer);
    var sharedState = { yy: {} };
    for (var k in this.yy) {
        if (Object.prototype.hasOwnProperty.call(this.yy, k)) {
            sharedState.yy[k] = this.yy[k];
        }
    }
    lexer.setInput(input, sharedState.yy);
    sharedState.yy.lexer = lexer;
    sharedState.yy.parser = this;
    if (typeof lexer.yylloc == 'undefined') {
        lexer.yylloc = {};
    }
    var yyloc = lexer.yylloc;
    lstack.push(yyloc);
    var ranges = lexer.options && lexer.options.ranges;
    if (typeof sharedState.yy.parseError === 'function') {
        this.parseError = sharedState.yy.parseError;
    } else {
        this.parseError = Object.getPrototypeOf(this).parseError;
    }
    function popStack(n) {
        stack.length = stack.length - 2 * n;
        vstack.length = vstack.length - n;
        lstack.length = lstack.length - n;
    }
            function lex() {
            var token;
            token = tstack.pop() || lexer.lex() || EOF;
            if (typeof token !== 'number') {
                if (token instanceof Array) {
                    tstack = token;
                    token = tstack.pop();
                }
                token = self.symbols_[token] || token;
            }
            return token;
        }
    var symbol, preErrorSymbol, state, action, a, r, yyval = {}, p, len, newState, expected;
    while (true) {
        state = stack[stack.length - 1];
        if (this.defaultActions[state]) {
            action = this.defaultActions[state];
        } else {
            if (symbol === null || typeof symbol == 'undefined') {
                symbol = lex();
            }
            action = table[state] && table[state][symbol];
        }
        if (typeof action === 'undefined' || !action.length || !action[0]) {
            var errStr = '';
            expected = [];
            for (p in table[state]) {
                if (this.terminals_[p] && p > TERROR) {
                    expected.push('\'' + this.terminals_[p] + '\'');
                }
            }
            if (lexer.showPosition) {
                errStr = 'Parse error on line ' + (yylineno + 1) + ':\n' + lexer.showPosition() + '\nExpecting ' + expected.join(', ') + ', got \'' + (this.terminals_[symbol] || symbol) + '\'';
            } else {
                errStr = 'Parse error on line ' + (yylineno + 1) + ': Unexpected ' + (symbol == EOF ? 'end of input' : '\'' + (this.terminals_[symbol] || symbol) + '\'');
            }
            this.parseError(errStr, {
                text: lexer.match,
                token: this.terminals_[symbol] || symbol,
                line: lexer.yylineno,
                loc: yyloc,
                expected: expected
            });
        }
        if (action[0] instanceof Array && action.length > 1) {
            throw new Error('Parse Error: multiple actions possible at state: ' + state + ', token: ' + symbol);
        }
        switch (action[0]) {
        case 1:
            stack.push(symbol);
            vstack.push(lexer.yytext);
            lstack.push(lexer.yylloc);
            stack.push(action[1]);
            symbol = null;
            if (!preErrorSymbol) {
                yyleng = lexer.yyleng;
                yytext = lexer.yytext;
                yylineno = lexer.yylineno;
                yyloc = lexer.yylloc;
                if (recovering > 0) {
                    recovering--;
                }
            } else {
                symbol = preErrorSymbol;
                preErrorSymbol = null;
            }
            break;
        case 2:
            len = this.productions_[action[1]][1];
            yyval.$ = vstack[vstack.length - len];
            yyval._$ = {
                first_line: lstack[lstack.length - (len || 1)].first_line,
                last_line: lstack[lstack.length - 1].last_line,
                first_column: lstack[lstack.length - (len || 1)].first_column,
                last_column: lstack[lstack.length - 1].last_column
            };
            if (ranges) {
                yyval._$.range = [
                    lstack[lstack.length - (len || 1)].range[0],
                    lstack[lstack.length - 1].range[1]
                ];
            }
            r = this.performAction.apply(yyval, [
                yytext,
                yyleng,
                yylineno,
                sharedState.yy,
                action[1],
                vstack,
                lstack
            ].concat(args));
            if (typeof r !== 'undefined') {
                return r;
            }
            if (len) {
                stack = stack.slice(0, -1 * len * 2);
                vstack = vstack.slice(0, -1 * len);
                lstack = lstack.slice(0, -1 * len);
            }
            stack.push(this.productions_[action[1]][0]);
            vstack.push(yyval.$);
            lstack.push(yyval._$);
            newState = table[stack[stack.length - 2]][stack[stack.length - 1]];
            stack.push(newState);
            break;
        case 3:
            return true;
        }
    }
    return true;
}};
/* generated by jison-lex 0.3.4 */
var lexer = (function(){
var lexer = ({

EOF:1,

parseError:function parseError(str, hash) {
        if (this.yy.parser) {
            this.yy.parser.parseError(str, hash);
        } else {
            throw new Error(str);
        }
    },

// resets the lexer, sets new input
setInput:function (input, yy) {
        this.yy = yy || this.yy || {};
        this._input = input;
        this._more = this._backtrack = this.done = false;
        this.yylineno = this.yyleng = 0;
        this.yytext = this.matched = this.match = '';
        this.conditionStack = ['INITIAL'];
        this.yylloc = {
            first_line: 1,
            first_column: 0,
            last_line: 1,
            last_column: 0
        };
        if (this.options.ranges) {
            this.yylloc.range = [0,0];
        }
        this.offset = 0;
        return this;
    },

// consumes and returns one char from the input
input:function () {
        var ch = this._input[0];
        this.yytext += ch;
        this.yyleng++;
        this.offset++;
        this.match += ch;
        this.matched += ch;
        var lines = ch.match(/(?:\r\n?|\n).*/g);
        if (lines) {
            this.yylineno++;
            this.yylloc.last_line++;
        } else {
            this.yylloc.last_column++;
        }
        if (this.options.ranges) {
            this.yylloc.range[1]++;
        }

        this._input = this._input.slice(1);
        return ch;
    },

// unshifts one char (or a string) into the input
unput:function (ch) {
        var len = ch.length;
        var lines = ch.split(/(?:\r\n?|\n)/g);

        this._input = ch + this._input;
        this.yytext = this.yytext.substr(0, this.yytext.length - len);
        //this.yyleng -= len;
        this.offset -= len;
        var oldLines = this.match.split(/(?:\r\n?|\n)/g);
        this.match = this.match.substr(0, this.match.length - 1);
        this.matched = this.matched.substr(0, this.matched.length - 1);

        if (lines.length - 1) {
            this.yylineno -= lines.length - 1;
        }
        var r = this.yylloc.range;

        this.yylloc = {
            first_line: this.yylloc.first_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.first_column,
            last_column: lines ?
                (lines.length === oldLines.length ? this.yylloc.first_column : 0)
                 + oldLines[oldLines.length - lines.length].length - lines[0].length :
              this.yylloc.first_column - len
        };

        if (this.options.ranges) {
            this.yylloc.range = [r[0], r[0] + this.yyleng - len];
        }
        this.yyleng = this.yytext.length;
        return this;
    },

// When called from action, caches matched text and appends it on next action
more:function () {
        this._more = true;
        return this;
    },

// When called from action, signals the lexer that this rule fails to match the input, so the next matching rule (regex) should be tested instead.
reject:function () {
        if (this.options.backtrack_lexer) {
            this._backtrack = true;
        } else {
            return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n' + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
            });

        }
        return this;
    },

// retain first n characters of the match
less:function (n) {
        this.unput(this.match.slice(n));
    },

// displays already matched input, i.e. for error messages
pastInput:function () {
        var past = this.matched.substr(0, this.matched.length - this.match.length);
        return (past.length > 20 ? '...':'') + past.substr(-20).replace(/\n/g, "");
    },

// displays upcoming input, i.e. for error messages
upcomingInput:function () {
        var next = this.match;
        if (next.length < 20) {
            next += this._input.substr(0, 20-next.length);
        }
        return (next.substr(0,20) + (next.length > 20 ? '...' : '')).replace(/\n/g, "");
    },

// displays the character position where the lexing error occurred, i.e. for error messages
showPosition:function () {
        var pre = this.pastInput();
        var c = new Array(pre.length + 1).join("-");
        return pre + this.upcomingInput() + "\n" + c + "^";
    },

// test the lexed token: return FALSE when not a match, otherwise return token
test_match:function(match, indexed_rule) {
        var token,
            lines,
            backup;

        if (this.options.backtrack_lexer) {
            // save context
            backup = {
                yylineno: this.yylineno,
                yylloc: {
                    first_line: this.yylloc.first_line,
                    last_line: this.last_line,
                    first_column: this.yylloc.first_column,
                    last_column: this.yylloc.last_column
                },
                yytext: this.yytext,
                match: this.match,
                matches: this.matches,
                matched: this.matched,
                yyleng: this.yyleng,
                offset: this.offset,
                _more: this._more,
                _input: this._input,
                yy: this.yy,
                conditionStack: this.conditionStack.slice(0),
                done: this.done
            };
            if (this.options.ranges) {
                backup.yylloc.range = this.yylloc.range.slice(0);
            }
        }

        lines = match[0].match(/(?:\r\n?|\n).*/g);
        if (lines) {
            this.yylineno += lines.length;
        }
        this.yylloc = {
            first_line: this.yylloc.last_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.last_column,
            last_column: lines ?
                         lines[lines.length - 1].length - lines[lines.length - 1].match(/\r?\n?/)[0].length :
                         this.yylloc.last_column + match[0].length
        };
        this.yytext += match[0];
        this.match += match[0];
        this.matches = match;
        this.yyleng = this.yytext.length;
        if (this.options.ranges) {
            this.yylloc.range = [this.offset, this.offset += this.yyleng];
        }
        this._more = false;
        this._backtrack = false;
        this._input = this._input.slice(match[0].length);
        this.matched += match[0];
        token = this.performAction.call(this, this.yy, this, indexed_rule, this.conditionStack[this.conditionStack.length - 1]);
        if (this.done && this._input) {
            this.done = false;
        }
        if (token) {
            return token;
        } else if (this._backtrack) {
            // recover context
            for (var k in backup) {
                this[k] = backup[k];
            }
            return false; // rule action called reject() implying the next rule should be tested instead.
        }
        return false;
    },

// return next match in input
next:function () {
        if (this.done) {
            return this.EOF;
        }
        if (!this._input) {
            this.done = true;
        }

        var token,
            match,
            tempMatch,
            index;
        if (!this._more) {
            this.yytext = '';
            this.match = '';
        }
        var rules = this._currentRules();
        for (var i = 0; i < rules.length; i++) {
            tempMatch = this._input.match(this.rules[rules[i]]);
            if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
                match = tempMatch;
                index = i;
                if (this.options.backtrack_lexer) {
                    token = this.test_match(tempMatch, rules[i]);
                    if (token !== false) {
                        return token;
                    } else if (this._backtrack) {
                        match = false;
                        continue; // rule action called reject() implying a rule MISmatch.
                    } else {
                        // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                        return false;
                    }
                } else if (!this.options.flex) {
                    break;
                }
            }
        }
        if (match) {
            token = this.test_match(match, rules[index]);
            if (token !== false) {
                return token;
            }
            // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
            return false;
        }
        if (this._input === "") {
            return this.EOF;
        } else {
            return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. Unrecognized text.\n' + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
            });
        }
    },

// return next match that has a token
lex:function lex () {
        var r = this.next();
        if (r) {
            return r;
        } else {
            return this.lex();
        }
    },

// activates a new lexer condition state (pushes the new lexer condition state onto the condition stack)
begin:function begin (condition) {
        this.conditionStack.push(condition);
    },

// pop the previously active lexer condition state off the condition stack
popState:function popState () {
        var n = this.conditionStack.length - 1;
        if (n > 0) {
            return this.conditionStack.pop();
        } else {
            return this.conditionStack[0];
        }
    },

// produce the lexer rule set which is active for the currently active lexer condition state
_currentRules:function _currentRules () {
        if (this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1]) {
            return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
        } else {
            return this.conditions["INITIAL"].rules;
        }
    },

// return the currently active lexer condition state; when an index argument is provided it produces the N-th previous condition state, if available
topState:function topState (n) {
        n = this.conditionStack.length - 1 - Math.abs(n || 0);
        if (n >= 0) {
            return this.conditionStack[n];
        } else {
            return "INITIAL";
        }
    },

// alias for begin(condition)
pushState:function pushState (condition) {
        this.begin(condition);
    },

// return the number of states currently on the stack
stateStackSize:function stateStackSize() {
        return this.conditionStack.length;
    },
options: {"case-insensitive":true},
performAction: function anonymous(yy,yy_,$avoiding_name_collisions,YY_START) {
var YYSTATE=YY_START;
switch($avoiding_name_collisions) {
case 0: this.begin("acc_title");return 19; 
break;
case 1: this.popState(); return "acc_title_value"; 
break;
case 2: this.begin("acc_descr");return 21; 
break;
case 3: this.popState(); return "acc_descr_value"; 
break;
case 4: this.begin("acc_descr_multiline");
break;
case 5: this.popState(); 
break;
case 6:return "acc_descr_multiline_value";
break;
case 7:/*{console.log('New line');return 13;}*/ return 13;
break;
case 8:/* skip comments */
break;
case 9:/* skip comments */
break;
case 10:return 5;
break;
case 11:return 39;
break;
case 12:return 32;
break;
case 13:return 37;
break;
case 14:return 41;
break;
case 15:return 42;
break;
case 16:return 43;
break;
case 17:return 44;
break;
case 18:return 45;
break;
case 19:return 28;
break;
case 20:return 29;
break;
case 21:return 36;
break;
case 22:return 31;
break;
case 23:return 34
break;
case 24:return 26;
break;
case 25:return 9;
break;
case 26:return 9;
break;
case 27:return 9;
break;
case 28:return 8;
break;
case 29:return 'CARET'
break;
case 30:this.begin("options"); //
break;
case 31:this.popState();       // not used anymore in the renderer, fixed for backward compatibility
break;
case 32:return 12;          //
break;
case 33:return 46;
break;
case 34:this.begin("string");
break;
case 35:this.popState();
break;
case 36:return 33;
break;
case 37:return 30;
break;
case 38:return 47; // only a subset of https://git-scm.com/docs/git-check-ref-format
break;
case 39:return 7;
break;
case 40:/* skip all whitespace */ // lowest priority so we can use lookaheads in earlier regex
break;
}
},
rules: [/^(?:accTitle\s*:\s*)/i,/^(?:(?!\n||)*[^\n]*)/i,/^(?:accDescr\s*:\s*)/i,/^(?:(?!\n||)*[^\n]*)/i,/^(?:accDescr\s*\{\s*)/i,/^(?:[\}])/i,/^(?:[^\}]*)/i,/^(?:(\r?\n)+)/i,/^(?:#[^\n]*)/i,/^(?:%[^\n]*)/i,/^(?:gitGraph\b)/i,/^(?:commit(?=\s|$))/i,/^(?:id:)/i,/^(?:type:)/i,/^(?:msg:)/i,/^(?:NORMAL\b)/i,/^(?:REVERSE\b)/i,/^(?:HIGHLIGHT\b)/i,/^(?:tag:)/i,/^(?:branch(?=\s|$))/i,/^(?:order:)/i,/^(?:merge(?=\s|$))/i,/^(?:cherry-pick(?=\s|$))/i,/^(?:parent:)/i,/^(?:\b(checkout|switch)(?=\s|$))/i,/^(?:LR\b)/i,/^(?:TB\b)/i,/^(?:BT\b)/i,/^(?::)/i,/^(?:\^)/i,/^(?:options\r?\n)/i,/^(?:[ \r\n\t]+end\b)/i,/^(?:[\s\S]+(?=[ \r\n\t]+end))/i,/^(?:["]["])/i,/^(?:["])/i,/^(?:["])/i,/^(?:[^"]*)/i,/^(?:[0-9]+(?=\s|$))/i,/^(?:\w([-\./\w]*[-\w])?)/i,/^(?:$)/i,/^(?:\s+)/i],
conditions: {"acc_descr_multiline":{"rules":[5,6],"inclusive":false},"acc_descr":{"rules":[3],"inclusive":false},"acc_title":{"rules":[1],"inclusive":false},"options":{"rules":[31,32],"inclusive":false},"string":{"rules":[35,36],"inclusive":false},"INITIAL":{"rules":[0,2,4,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,33,34,37,38,39,40],"inclusive":true}}
});
return lexer;
})();
parser.lexer = lexer;
function Parser () {
  this.yy = {};
}
Parser.prototype = parser;parser.Parser = Parser;
return new Parser;
})(); 
	parser.parser = parser;
	export { parser };
	export default parser;
	